'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createdInstance = null;

var ThemeManager = function () {
    function ThemeManager(state) {
        (0, _classCallCheck3.default)(this, ThemeManager);

        this.state = state;
        this.listenForIrcEvents();
        this.varsEl = null;
    }

    (0, _createClass3.default)(ThemeManager, [{
        key: 'themeVar',
        value: function themeVar(varName) {
            if (!this.varsEl) {
                this.varsEl = document.querySelector('.kiwi-wrap');
            }

            var styles = window.getComputedStyle(this.varsEl);
            var v = styles.getPropertyValue('--kiwi-' + varName);
            return (v || '').trim();
        }
    }, {
        key: 'availableThemes',
        value: function availableThemes() {
            return this.state.settings.themes;
        }
    }, {
        key: 'currentTheme',
        value: function currentTheme() {
            var state = this.state;
            var currentThemeName = state.setting('theme');
            currentThemeName = currentThemeName.toLowerCase();

            var theme = _lodash2.default.find(state.settings.themes, function (t) {
                var isMatch = t.name.toLowerCase() === currentThemeName;
                return isMatch;
            });

            if (!theme) {
                theme = state.settings.themes[0];
            }

            return theme;
        }
    }, {
        key: 'setTheme',
        value: function setTheme(theme) {
            var theTheme = null;

            if (typeof theme === 'string') {
                theTheme = _lodash2.default.find(this.availableThemes(), function (t) {
                    var isMatch = t.name.toLowerCase() === theme.toLowerCase();
                    return isMatch;
                });

                if (!theTheme) {
                    return;
                }
            } else {
                theTheme = theme;
            }

            this.state.setting('theme', theTheme.name);
            this.state.$emit('theme.change');
        }
    }, {
        key: 'reload',
        value: function reload() {
            var theme = this.currentTheme();
            if (!theme) {
                return;
            }

            var url = theme.url;
            if (url.indexOf('cb=') > -1) {
                url = url.replace(/cb=[0-9]+/, function () {
                    return 'cb=' + Date.now();
                });
            } else if (url.indexOf('?') > -1) {
                url += '&cb=' + Date.now();
            } else {
                url += '?cb=' + Date.now();
            }

            theme.url = url;
            this.state.$emit('theme.change');
        }
    }, {
        key: 'setCustomThemeUrl',
        value: function setCustomThemeUrl(url) {
            var theme = _lodash2.default.find(ThemeManager.instance().availableThemes(), {
                name: 'custom'
            });

            if (theme) {
                theme.url = url;
            }

            if (theme.name === 'custom') {
                this.state.$emit('theme.change');
            }
        }
    }, {
        key: 'listenForIrcEvents',
        value: function listenForIrcEvents() {
            var _this = this;

            this.state.$on('irc.ctcp request', function (event, network) {
                var ctcpType = (event.type || '').toLowerCase();
                if (ctcpType === 'kiwi' && event.message.indexOf('theme reload') > -1) {
                    _this.reload();
                }
            });
        }
    }], [{
        key: 'themeUrl',
        value: function themeUrl(theme) {
            var parts = theme.url.split('?');
            var url = parts[0];
            var qs = parts[1] || '';

            if (url[url.length - 1] !== '/') {
                url += '/';
            }
            return url + 'theme.css' + (qs ? '?' + qs : '');
        }
    }]);
    return ThemeManager;
}();

exports.default = ThemeManager;


ThemeManager.instance = function instance(state) {
    if (!createdInstance) {
        createdInstance = new ThemeManager(state);
    }

    return createdInstance;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ThemeManager"]
window._kiwi_exports.libs.ThemeManager = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/ThemeManager.js
// module id = j/A4
// module chunks = 1